module.exports = __webpack_public_path__ + "img/dailes-teatris.6071cf60.png";